import { Chart, ChartOption } from './Chart';
import { Box } from '@mui/material';

const BarChart = () => {
  const option = {
    title: {
      text: 'Inadimplência por categoria ',
      textStyle: {
        fontSize: '14px'
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {
      right: '0',
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      data: ['']
    },
    yAxis: {
      type: 'category',
      data: ['Mensalidade Infantil I', 'Ensino médio I', 'Futsal', 'Infantil III', 'Integral fundamental', 'Mensalidade Infantil II'],
    },
    series: [
      {
        name: 'Inadimplência',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: (params: { value: number; }) => Math.round(params.value) + '%'
        },
        itemStyle: {
          color: '#E04A4C',
        },
        emphasis: {
          focus: 'series',
        },
        data: [10, 8, 7,12, 4, 5],
      },
      {
        name: 'Inadimplência acumulada',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: (params: { value: number; }) => Math.round(params.value) + '%'
        },
        itemStyle: {
          color: '#000',
        },
        emphasis: {
          focus: 'series',
        },
        data: [9, 6, 7,4, 5, 8],
      },
    ],
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default BarChart;
